export const ANIMATION_DURATION_STANDARD = 300;
